
$(document).ready(function(){  
  console.log('console ready');


  /*** Start script for mini cart **/

  /** remove class when hover out mini cart for desktop view **/
  $(document).on('mouseleave', '.art_icon_cart_header', function(){
    console.log('mouse out');
    $('.art_icon_cart_header').removeClass('art_icon_cart_header_open_mini');
    $('body').removeClass('mini_cart_open');
  });
  /** remove class when hover out mini cart for desktop view **/

  /** mobile view click cart icon js **/

  $(document).click(function(e) {

    console.log(e);
    console.log(e.target);
    if(e.target.className == 'art_footer_links_head h4'){
      console.log('do nothing');
    } else{
      if(e.target.className == 'fal fa-shopping-cart'){
        console.log('clicked on icon');

        if ($('.art_mob_cart_icon').hasClass("art_icon_cart_header_open_mini")) {
          $('.art_mob_cart_icon').removeClass('art_icon_cart_header_open_mini');
          $('body').removeClass('mini_cart_open');
        } else{
          $('.art_mob_cart_icon').addClass('art_icon_cart_header_open_mini');
          $('body').addClass('mini_cart_open');
        }

      } else{
        console.log('clicked outside icon');
        var container = $(".art-sp-cart-drwr");
        var cartIcon= $('.art_mob_cart_icon');

        // if the target of the click isn't the container nor a descendant of the container
        if ((!container.is(e.target) && container.has(e.target).length === 0) ) {
          //container.hide();
          $('.art_mob_cart_icon').removeClass('art_icon_cart_header_open_mini');
          $('body').removeClass('mini_cart_open');
        } 
      }
    }



  });


  /** mobile view click cart icon js **/

  // ajax mini cart remove item from cart 
  $(document).on('click', 'a.art_cart_remove', function(){
    var itemKey= $(this).attr('data-cart-item-key');
    //console.log('remove cart clicked, itemKey: '+itemKey);
    
    jQuery.post('/cart/update.js', "updates["+itemKey+"]=0");
    
    setTimeout(function(){ 
      //location.reload();
      $.ajax({
        type: 'GET',
        url: 'https://artofentertainment.com/cart.json',
        dataType: 'json',
        success: function(data) {
         
          var Cart_total_item_count = data.item_count;
          $('.art_mob_cart_count').text(Cart_total_item_count);
          $('.art_desk_cart_count span').text(Cart_total_item_count);
          if(Cart_total_item_count > 0){
            // if any item in cart
            var itm = data.items;
            var subtotal_withoutPrice= data.total_price;
            var subtotal_price = data.total_price /100;
            var itmlenth = itm.length;
            console.log('count: '+Cart_total_item_count);
           
            
           var cus_compare_price="";
            var total_savings = 0;

            var ref = $('.product-form__cart-submit').data('ref');

            var htmlmini='';
            for(var i=0;i<itmlenth;i++)
            {
              var singleItemPrice= itm[i].price /100;
               var itmid = itm[i].id;
               var items_savings = 0;
              
                   $.ajax({
                    dataType: "json",
                    async: false,
                    cache: false,
                    url: "/products/" + itm[i].handle + ".js",
                    success: function(data) {
                      var variant = $.grep(data.variants, function(v) {
                        return v.id == itmid;
                      });
                      
                      var compare_pri = variant[0].compare_at_price;
                      var main_pri = variant[0].price ;

                      if(variant[0].compare_at_price > variant[0].price){
                         cus_compare_price = variant[0].compare_at_price / 100;
                         items_savings = parseInt(compare_pri - main_pri) / 100;
                      }
                  
                      if(compare_pri > main_pri) {
                        var saving_total = parseInt((compare_pri - main_pri) * itm[i].quantity) / 100;
                        total_savings = saving_total + total_savings;
                        
                      }
                      
                    }
                  });

              if(items_savings > 0){ 
                htmlmini +='<div class="art-sp-cart-drwr-row">'
                +'<div class="art-sp-cart-drwr-img">'
                +'<img src="'+itm[i].image+'" />'
                +'</div>'
                +'<div class="art-sp-cart-drwr-info">'
                +'<div class="art-sp-cart-drwr-info-tpr">'
               +'<div class="art-sp-cart-drwr-info-price ajax-cart__price price"><span class="original_price money">$'+singleItemPrice+'</span><span class="compare_price money was-price">$'+cus_compare_price+'</span></div>'
                +'<h3>'+itm[i].product_title+'</h3>'
                +'</div>'
                +'<ul>'
                +'<li>In Stock</li>'
                +'<li>NO: '+itm[i].sku+'</li>'
                +'</ul>'
                + '<div class="ajax_saving_price" style="color:red;">Savings: $'+ items_savings +'</div>'
                +'<div class="art-sp-cart-drwr-info-qty-rmv">'
                +'<div class="art-sp-cart-drwr-info-qty">'
                +'<div class="control quantity-input-control"><input class="art_cart_qty" type="number" data-cart-item-key="'+itm[i].key+'" value="'+itm[i].quantity+'" min="0" pattern="[0-9]*" /></div>'
                +'</div>'
                +'<div class="art-sp-cart-drwr-info-rmv">'
                +'<a class="art_cart_remove" data-ajax-cart-delete="" data-cart-item-key="'+itm[i].key+'" href="javascript:;" data-href="/cart/change?line=1&amp;quantity=0" title="remove">Remove</a>'
                +'</div>'
                +'</div>'
                +'</div>'
                +'</div>';
              }else{
                htmlmini +='<div class="art-sp-cart-drwr-row">'
                +'<div class="art-sp-cart-drwr-img">'
                +'<img src="'+itm[i].image+'" />'
                +'</div>'
                +'<div class="art-sp-cart-drwr-info">'
                +'<div class="art-sp-cart-drwr-info-tpr">'
                +'<div class="art-sp-cart-drwr-info-price ajax-cart__price price"><span class="original_price money">$'+singleItemPrice+'</span></div>'
                +'<h3>'+itm[i].product_title+'</h3>'
                +'</div>'
                +'<ul>'
                +'<li>In Stock</li>'
                +'<li>NO: '+itm[i].sku+'</li>'
                +'</ul>'
                +'<div class="art-sp-cart-drwr-info-qty-rmv">'
                +'<div class="art-sp-cart-drwr-info-qty">'
                +'<div class="control quantity-input-control"><input class="art_cart_qty" type="number" data-cart-item-key="'+itm[i].key+'" value="'+itm[i].quantity+'" min="0" pattern="[0-9]*" /></div>'
                +'</div>'
                +'<div class="art-sp-cart-drwr-info-rmv">'
                +'<a class="art_cart_remove" data-ajax-cart-delete="" data-cart-item-key="'+itm[i].key+'" href="javascript:;" data-href="/cart/change?line=1&amp;quantity=0" title="remove">Remove</a>'
                +'</div>'
                +'</div>'
                +'</div>'
                +'</div>';
              }
            }
            $('.art-sp-cart-drwr-body-inn').html(htmlmini);
            if(subtotal_withoutPrice >= '9900'){
              $('.art_cart_message_ajax p').html("You've earned FREE SHIPPING");
            } else{
              $('.art_cart_message_ajax p').html("");
            }
            $('.art-sp-cart-drwr-total p').html("Subtotal: <span>$"+subtotal_price.toFixed(2)+"</span>");
              if(total_savings > 0){
                $('.art-sp-cart-drwr-total-saving p').html("Total Savings: <span>$"+total_savings+"</span>");
              }else{
                $('.art-sp-cart-drwr-total-saving p').html("");
              }
            
            $('.art_icon_cart_header').addClass('art_icon_cart_header_open_mini');
          } else{
            // if no item in cart
            console.log('no item in cart');
            var htmlmini='';
            htmlmini +='<div class="art_cart_no_item">'
            +'<p>No item in cart</p>'
            +'</div>';
            $('.art-sp-cart-drwr-body-inn').html(htmlmini);
            $('.art-sp-cart-drwr-total p').html("");
            $('.art_cart_message_ajax p').html("");
            $('.art-sp-cart-drwr-total-saving p').html("");
          }

        }
      });


    }, 1000); 
  });
  // ajax mini cart remove iten form cart


  // ajax mini cart update quantity of item in cart
  $(document).on('change', '.art_cart_qty', function(){
    var itemKey= $(this).attr('data-cart-item-key');
    var newQuantity= $(this).val();
    console.log('update cart clicked, itemKey: '+itemKey+", newQuantity: "+newQuantity);

    jQuery.post('/cart/update.js',
                "updates["+itemKey+"]="+parseInt(newQuantity)
               );
    setTimeout(function(){ 
      //location.reload();
      $.ajax({
        type: 'GET',
        url: 'https://artofentertainment.com/cart.json',
        dataType: 'json',
        success: function(data) {
          console.log(data);
          var Cart_total_item_count = data.item_count;
          $('.art_mob_cart_count').text(Cart_total_item_count);
          $('.art_desk_cart_count span').text(Cart_total_item_count);
          if(Cart_total_item_count > 0){
            // if any item in cart
            var itm = data.items;
            var subtotal_withoutPrice= data.total_price;
            var subtotal_price = data.total_price /100;
            var itmlenth = itm.length;
            console.log('count: '+Cart_total_item_count);
            
              var cus_compare_price="";
              var total_savings = 0;
            
             var ref = $('.product-form__cart-submit').data('ref');
            
            var htmlmini='';
            for(var i=0;i<itmlenth;i++)
            {
              var singleItemPrice= itm[i].price /100;
               var itmid = itm[i].id;
              
              var items_savings = 0;
              
                  $.ajax({
                    dataType: "json",
                    async: false,
                    cache: false,
                    url: "/products/" + itm[i].handle + ".js",
                    success: function(data) {
                      var variant = $.grep(data.variants, function(v) {
                        return v.id == itmid;
                      });
                      
                      var compare_pri = variant[0].compare_at_price;
                      var main_pri = variant[0].price ;

                      if(variant[0].compare_at_price > variant[0].price){
                         cus_compare_price = variant[0].compare_at_price / 100;
                         items_savings = parseInt(compare_pri - main_pri) / 100;
                      }
                  
                      if(compare_pri > main_pri) {
                        var saving_total = parseInt((compare_pri - main_pri) * itm[i].quantity) / 100;
                        total_savings = saving_total + total_savings;
                        
                      }
                      
                    }
                  });
         
     
              if(items_savings > 0){ 
                htmlmini +='<div class="art-sp-cart-drwr-row">'
                +'<div class="art-sp-cart-drwr-img">'
                +'<img src="'+itm[i].image+'" />'
                +'</div>'
                +'<div class="art-sp-cart-drwr-info">'
                +'<div class="art-sp-cart-drwr-info-tpr">'
                +'<div class="art-sp-cart-drwr-info-price ajax-cart__price price"><span class="original_price money">$'+singleItemPrice+'</span><span class="compare_price money was-price">$'+cus_compare_price+'</span></div>'
                +'<h3>'+itm[i].product_title+'</h3>'
                +'</div>'
                +'<ul>'
                +'<li>In Stock</li>'
                +'<li>NO: '+itm[i].sku+'</li>'
                +'</ul>'
                + '<div class="ajax_saving_price" style="color:red;">Savings: $'+ items_savings +'</div>'
                +'<div class="art-sp-cart-drwr-info-qty-rmv">'
                +'<div class="art-sp-cart-drwr-info-qty">'
                +'<div class="control quantity-input-control"><input class="art_cart_qty" type="number" data-cart-item-key="'+itm[i].key+'" value="'+itm[i].quantity+'" min="0" pattern="[0-9]*" /></div>'
                +'</div>'
                +'<div class="art-sp-cart-drwr-info-rmv">'
                +'<a class="art_cart_remove" data-ajax-cart-delete="" data-cart-item-key="'+itm[i].key+'" href="javascript:;" data-href="/cart/change?line=1&amp;quantity=0" title="remove">Remove</a>'
                +'</div>'
                +'</div>'
                +'</div>'
                +'</div>';
              }else{
                htmlmini +='<div class="art-sp-cart-drwr-row">'
                +'<div class="art-sp-cart-drwr-img">'
                +'<img src="'+itm[i].image+'" />'
                +'</div>'
                +'<div class="art-sp-cart-drwr-info">'
                +'<div class="art-sp-cart-drwr-info-tpr">'
                +'<div class="art-sp-cart-drwr-info-price ajax-cart__price price"><span class="original_price money">$'+singleItemPrice+'</span></div>'
                +'<h3>'+itm[i].product_title+'</h3>'
                +'</div>'
                +'<ul>'
                +'<li>In Stock</li>'
                +'<li>NO: '+itm[i].sku+'</li>'
                +'</ul>'
                +'<div class="art-sp-cart-drwr-info-qty-rmv">'
                +'<div class="art-sp-cart-drwr-info-qty">'
                +'<div class="control quantity-input-control"><input class="art_cart_qty" type="number" data-cart-item-key="'+itm[i].key+'" value="'+itm[i].quantity+'" min="0" pattern="[0-9]*" /></div>'
                +'</div>'
                +'<div class="art-sp-cart-drwr-info-rmv">'
                +'<a class="art_cart_remove" data-ajax-cart-delete="" data-cart-item-key="'+itm[i].key+'" href="javascript:;" data-href="/cart/change?line=1&amp;quantity=0" title="remove">Remove</a>'
                +'</div>'
                +'</div>'
                +'</div>'
                +'</div>';
              }
              
              
              
            }
            $('.art-sp-cart-drwr-body-inn').html(htmlmini);
            if(subtotal_withoutPrice >= '9900'){
              $('.art_cart_message_ajax p').html("You've earned FREE SHIPPING");
            } else{
              $('.art_cart_message_ajax p').html("");
            }
            $('.art-sp-cart-drwr-total p').html("Subtotal: <span>$"+subtotal_price.toFixed(2)+"</span>");

            if(total_savings > 0){
              $('.art-sp-cart-drwr-total-saving p').html("Total Savings: <span>$"+total_savings+"</span>");
            }else{
              $('.art-sp-cart-drwr-total-saving p').html("");
            }


            $('.art_icon_cart_header').addClass('art_icon_cart_header_open_mini');
          } else{
            // if no item in cart
            console.log('no item in cart');
            var htmlmini='';
            htmlmini +='<div class="art_cart_no_item">'
            +'<p>No item in cart</p>'
            +'</div>';
            $('.art-sp-cart-drwr-body-inn').html(htmlmini);
            $('.art-sp-cart-drwr-total p').html("");
            $('.art-sp-cart-drwr-total-saving p').html("");
            $('.art_cart_message_ajax p').html("");
          }

        }
      });


    }, 1000); 

  });
  // ajax mini cart update quantity of item in cart



  /*** End script for mini cart **/





  // Start hover effect for desktop view main nav
  function resizeForm(){
    var width = (window.innerWidth > 0) ? window.innerWidth : document.documentElement.clientWidth;
    if(width < 750) {
      //auto add height for mobile bar
      var Heoghtcstm_main_top_bar= $('.cstm_main_top_bar').height();
      var Heightart_mob_header_upr= $('.art-mob-header-upr').height();
      var FinalHeight= Heoghtcstm_main_top_bar+Heightart_mob_header_upr;
      console.log("Heoghtcstm_main_top_bar: "+Heoghtcstm_main_top_bar+", Heightart_mob_header_upr: "+Heightart_mob_header_upr+", FinalHeight: "+FinalHeight);
      $('.art-mob-menu-sec').css('top',FinalHeight+'px');

      // menu accordion footer mobile

      var acc = document.getElementsByClassName("art_footer_links_head");
      var i;
      for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function() {
          this.classList.toggle("openAccorBtn");
          var panel = this.nextElementSibling;
          console.log(panel.offsetHeight);
          if (panel.style.display === "block") {
            panel.style.display = "none";
          } else {
            panel.style.display = "block";
          }
        });
      }


      // about pages mobile nav
      $(document).on('touchstart', '.art-mobile-list-btn', function(){
        console.log('test click btn');
        $(this).toggleClass('EnableMenuAbt');
        $(this).siblings('.art-mobile-list-block').toggleClass('openMenuAbt');
        if ($(this).hasClass("EnableMenuAbt")) {
          $(this).siblings('.art-mobile-list-block').show();
        } else{
          $(this).siblings('.art-mobile-list-block').hide();
        }
      });


    } // if mob menu 
    else{

      // if ($('body').hasClass("template-product")) {
      //   $(".art_desk_cust_slider").slick({
      //     dots: true,
      //     infinite: true,
      //     arrows: true,
      //     nextArrow: '<strong class="fa fa-arrow-right">Next</strong>',
      //     prevArrow: '<strong class="fa fa-arrow-left">Prev</strong>',
      //     slidesToShow: 3,
      //     slidesToScroll: 1
      //   });
      // }

    } // if desktop version
  }
  window.onresize = resizeForm;
  resizeForm();
  // End hover effect for desktop view main nav


  $(document).on('click','.art-video-play', function(){
    console.log('click video play button');
    $(this).parent().removeClass('artist-left-vid-inn-icon');
    var video = '<iframe id="videoPlay" src="'+ $(this).attr('data-video') +'" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
    $(this).replaceWith(video);
  });


  // mobile toggle menu
  $(document).on('touchstart', 'a.art_toggle_mob', function(){
    console.log('toggle click mobile');
    $(this).toggleClass('OpenToggle');
    $('.art-mob-menu-sec').toggleClass('OpenMobMenu');
    $('body').toggleClass('BodyToggleOpen');
    $('html').toggleClass('BodyToggleOpen');
    if ($("body").hasClass("BodyToggleOpen")) {
      console.log("yes");
      $('.art-mob-menu-sec').slideDown(1000);
    } else{
      console.log("no");
      $('.art-mob-menu-sec').slideUp(600);
    }
  });
  // end mobile toggle menu
  // submenu open of mobile toggle menu
  $(document).on('touchstart', '.art-mob-has-submenu a', function(){
    console.log('clicked submenu');
    if ($(this).parent().hasClass("openSubMenuBtn")) {
      $(this).parent().removeClass('openSubMenuBtn');
      $(this).parent().find('.art-mob-submenu-list').slideUp(600);
    } else{
      $(this).parent().addClass('openSubMenuBtn');
      $(this).parent().find('.art-mob-submenu-list').slideDown(600);
    }
  });
  // end submenu open of mobile toggle menu


  /** Start script for product page only **/
  if ($('body').hasClass("template-product")) {


    // start tabs script
    $('ul.art_desk_tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
    // end tabs script



    // accordion product tabs mobile
    $(document).on('click', '.art_acc_head_prd', function(){
      var currentLi= $(this);
      var hrefdata= currentLi.find('a').attr('data-href');
      console.log('clicked footer accordion p');
      if (currentLi.hasClass("openAccorBtn")) {
        currentLi.removeClass('openAccorBtn');
        $('.inner_acc_content#'+hrefdata).slideUp(600);
      } else{
        currentLi.addClass('openAccorBtn');
        $('.inner_acc_content#'+hrefdata).slideDown(600);
      }
    });


    // start video script 
    $(".product-single__media--has-thumbnails").each(function(index) {
      var This= $(this);
      var Imgalt= This.find('img').attr('alt');
      console.log(index+", alt: "+Imgalt);
      if(Imgalt.indexOf('youtube') != -1){
        //console.log("youtube found");
        //This.find('img').remove();
        //This.find('.video_frame').show();
      }


    });
    // end video script


    // start script for tab2 variant data 
    var variant_id = $('.hidden_variant_id').data('id');
    console.log("current selected variant: "+variant_id);
    if ($.trim($('.cgt-content #tab-2 .variant-spec_content[data-id="'+variant_id+'"]').html()) != '') {
      $('.cgt-content #tab-2 .product-spec_content').hide();
      $('.cgt-content #tab-2 .variant-spec_content[data-id="'+variant_id+'"]').addClass('selected');
    } else {
      $('.cgt-content #tab-2 .product-spec_content').show();
    }

    if ($.trim($('#tabcon-2 .variant-spec_content[data-id="'+variant_id+'"]').html()) != '') {
      $('#tabcon-2 .product-spec_content').hide();
      $('#tabcon-2 .variant-spec_content[data-id="'+variant_id+'"]').addClass('selected');
    } else {
      $('#tabcon-2 .product-spec_content').show();
    }
    // end script for tab2 variant data

  }
  /** End script for product page only **/

  if ($('body').hasClass("template-blog")) {

    $(document).on('click', '.topic_dropdown', function(){
      var thisli= $(this);
      $('.topic_dropdown').removeClass('topic_dropdown_open');
      thisli.addClass('topic_dropdown_open');
    });

    $(document).on('click', '.search_icon_mob', function(){
      $('.boost-pfs-search-suggestion-mobile-top-panel').css('display','block');
      $('.boost-pfs-search-suggestion-mobile-overlay').css('display','block');
    });


    $.noConflict();
    // masonary function starts
    $('.art-mas-grid').masonry({
      // options
      itemSelector: '.art-mas-grid-item',
      gutter: 0
    });
  }



  if ($('body').hasClass("template-cart")) {
    console.log('cart page');
    $(document).on('click', '.art_qty_dec', function(){
      var thisDInp= $(this);
      var getCQtyD= parseInt(thisDInp.siblings('input').val());
      console.log("getCQtyD: "+getCQtyD);
      var newInputD= getCQtyD-1;
      thisDInp.siblings('input').val(newInputD);
      console.log(thisDInp.siblings('input').val());
      thisDInp.siblings('input').change();
    });
    $(document).on('click', '.art_qty_inc', function(){
      var thisIInp= $(this);
      var getCQtyI= parseInt(thisIInp.siblings('input').val());
      console.log("getCQtyI: "+getCQtyI);
      var newInputI= getCQtyI+1;
      thisIInp.siblings('input').val(newInputI);
      console.log(thisIInp.siblings('input').val());
      thisIInp.siblings('input').change();
    });
  }


  /** Start script shop by character page **/
  $('.art_li_alpha').click(function() {
    var current_li= $(this);
    $('.art_li_alpha').removeClass('active-chr');
    current_li.addClass('active-chr');
    if (current_li.hasClass("no_block")) {
      console.log('no inner block');
    } else{
      var getClass= current_li.attr('data-target');
      $('.art-sbchr-info-box').removeClass('art-sbchr-info-box-active');
      $("div#"+getClass).find('.art-sbchr-info-box').addClass('art-sbchr-info-box-active');
      $('html, body').animate({
        scrollTop: $("div#"+getClass).offset().top
      }, 1000);
    }
  });
  /** End script shop by character page **/



  // add to cart on product listing hover
  $(document).on('click', 'a.art_prd_list_act', function(){
    var getVarID= $(this).attr('data-var-id');
    var getVarPrimarySKU= $(this).attr('data-var-primary_sku');
    var getVarSecondarySKU= $(this).attr('data-var-secondary_sku');
    //console.log("----------------");
    //console.log("getVarID: "+getVarID);
    //console.log("getVarPrimarySKU: "+getVarPrimarySKU);
    //console.log("getVarSecondarySKU: "+getVarSecondarySKU);
    if(getVarID != ""){
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { quantity: 1, id: getVarID ,
               properties: {
                 'SKU': getVarPrimarySKU,
                 'Option': getVarSecondarySKU
               }
              },
        dataType: 'json',
        async:false,
        success: function(data) { 
          window.location.href = '/cart';
        }
      });

    }
  });
  // end add to cart on product listing hover





  $(document).on('click', 'a.art_scrool_to_top', function(){
    $('html, body').animate({
      scrollTop: $("header.ArtEntHeader").offset().top
    }, 1000);
  });



  $(window).scroll(function () {
    if ($(this).scrollTop() > 50) {
      $('body').addClass("art_scroll_top_enabled");
    } else {
      $('body').removeClass("art_scroll_top_enabled");
    }
  });



}); // end document ready


